import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};
export const LoginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + "Authentication/login",
      credentials,
      {
        headers: {
          
          'Content-Type': 'application/json',
          //  Authorization: `Bearer ${getToken()}`
          // 'Access-Control-Allow-Origin':'*',
          // Other headers you want to include
        },
      }
    );
    //console.log(token,"token");
    return response.data;
    
  } catch (error) {
    throw error;
    // console.log(error)
  }
};

export const LogoutUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + "Authentication/logout",
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
          // You can add other headers if needed
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


// export const fetchUserPermissions = async () => {
//   try {
//     // Fetch role-based permissions
//     const rolePermissionsResponse = await axios.get(`${API_BASE_URL1}MasterDetails/GetAllUserRolePermission`);
//     const rolePermissions = rolePermissionsResponse.data;
  
//     // Fetch individual permissions
//     const individualPermissionsResponse = await axios.get(`${API_BASE_URL1}MasterDetails/GetAllUserRolePermission`);
//     const individualPermissions = individualPermissionsResponse.data;

//     // Check if user has 'can edit' permission
//     const canEditFromRoles = rolePermissions.some(permission => permission.permissionName === 'can edit' && permission.canWrite);
//     const canEditFromIndividual = individualPermissions.some(permission => permission.permissionName === 'can edit');

//     // Check if user has 'can add' permission
//     const canAddFromRoles = rolePermissions.some(permission => permission.permissionName === 'can add' && permission.canWrite);
//     const canAddFromIndividual = individualPermissions.some(permission => permission.permissionName === 'can add');

//     console.log(rolePermissions)
//     console.log(individualPermissions)


//     return {
//       canEdit: canEditFromRoles || canEditFromIndividual,
//       canAdd: canAddFromRoles || canAddFromIndividual
//     };
//   } catch (error) {
//     console.error('Error fetching user permissions:', error);
//     return {
//       canEdit: false,
//       canAdd: false
//     };
//   }
// };
export const GetAllRolePermissionByRoleId = async (RoleId) => {
  const token = localStorage.getItem('token');
  try {
    if (!token) {
      throw new Error('Token is missing');
    }

    const response = await axios.get(
      `${API_BASE_URL1}MasterDetails/GetAllUserRolePermission`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("editPermissions",response.data)
    return response.data;
  } catch (error) {
    console.error('Error in GetAllRolePermissionByRoleId:', error);
    throw error;
  }
};



export const GetAllRolePermissions = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {          
      throw new Error('Token not found.');
    }

    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllRolePermissions`,
      {
        headers: {
          
          'Content-Type': 'application/json',
           Authorization: `Bearer ${getToken()}`,
          // Oth
        }
      },
    );
    // console.log(response, 'ROLE PERMISSIONS')
    return response.data;
  } catch (error) {
    throw error;
    // console.log(error)
  }
};
